import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { assistantPublishMessage } from '../messages/assistantPublishMesage';
import { streamingPublishMessage } from '../messages/streamingPublishMessage';
import { streamEventPublishMessage } from '../messages/streamEventPublishMessage';
import { conversationResolvedPublishMessage } from '../messages/conversationResolvedPublishMessage';
import { newThreadConversationCreatedPublishMessage } from '../messages/newThreadConversationCreatedPublishMessage';
const ASSISTANT_TOPIC = 'ASSISTANT_TOPIC';

// Exported as the builder so tests can flip excludeSelf(false) and receive their
// own publishes in a single window. Restore in afterEach. See the Magpie one-pager.
export const assistantTopicFilter = AudienceFilter.builder().crossPortal();
export const AssistantTopicDef = defineTopic({
  name: ASSISTANT_TOPIC,
  messages: [assistantPublishMessage, streamingPublishMessage, streamEventPublishMessage, conversationResolvedPublishMessage, newThreadConversationCreatedPublishMessage],
  enableRuntimeValidation: false,
  audience: assistantTopicFilter.build()
});